import type { HsCamera } from '../../engine-new/objects/cameras/camera.class';
import type { HsMatrix4 } from '../../math-new/objects/matrix4.class';
import { HsGlobal } from '../global';
import { HsOutputMessageObject } from '../messages/output-message-object.class';
import { HsOutputMessageType } from '../messages/output-message-type.enum';

export function hsApplyTransformationToCamera(camera: HsCamera, matrix: HsMatrix4): void {
  camera.worldMatrix.setFromArray(matrix.values);
  camera.updateFrustum();
  const message: HsOutputMessageObject = new HsOutputMessageObject(HsOutputMessageType.CameraTransform);
  HsGlobal.outputMessages.next(message);
}
